import React, {useEffect, useState, useRef} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/swiper-bundle.min.css";
import {Img} from "./Img";
import reactHtmlParser from "react-html-parser";
import {LightgalleryItem, LightgalleryProvider} from "react-lightgallery";
import "lightgallery.js/dist/css/lightgallery.css";
import ReactHtmlParser from "react-html-parser";


const DetailList = ({sliderImageData, textData, title}) => {
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    let speedValue = 900;
    return (
        <StyledComponent>
            <LightgalleryProvider>
                <Container>
                    <Row className={'person-wrap'}>
                        <Col lg={6} sm={12}>
                            {/* Left Swiper */}
                            {sliderImageData?.length > 0 && (
                                <Swiper
                                    initialSlide={1} // The initial slide index.
                                    spaceBetween={20} // Space between slides.
                                    slidesPerView={1} // Ensures only one slide is visible.
                                    navigation={{
                                        nextEl: '.right-button-next',
                                        prevEl: '.right-button-prev',
                                    }} // Set navigation buttons.
                                    onSlideChange={(swiper) => {
                                        setIsBeginning(swiper.isBeginning); // Checks if the first slide is active.
                                        setIsEnd(swiper.isEnd); // Checks if the last slide is active.
                                    }}
                                    noSwiping={true} // Disables swiping interaction.
                                    noSwipingClass="swiper-no-swiping"
                                    speed={speedValue || 1200} // Speed of transition.
                                    loop={false} // Prevents looping for sequential navigation.
                                    slideToClickedSlide={true} // Enables clicking slides to navigate.
                                >
                                    {sliderImageData.map((item, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="img-item">
                                                <LightgalleryItem src={item?.full_path}>
                                                    <Img src={item?.full_path} />
                                                </LightgalleryItem>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            )}


                            {
                                sliderImageData &&
                                <div className="nav-menu">

                                    <div
                                        className={`right-button-prev ${isBeginning ? 'dimmed' : ''}`}
                                    >
                                        {/* SVG for previous button */}
                                        <img src="/images/static/arrow-right.svg" alt="arrow right"/>
                                    </div>
                                    <div
                                        className={`right-button-next ${isEnd ? 'dimmed' : ''}`}
                                    >
                                        {/* SVG for next button */}
                                        <img src="/images/static/arrow-right.svg" alt="arrow right"/>
                                    </div>
                                </div>
                            }
                        </Col>
                        <Col lg={6} sm={12}>
                            <div className="single-slide">
                                {
                                    textData?.product_data?.title && <div className="single-slide__single">
                                        <h5>{textData?.product_data?.title}</h5>
                                    </div>
                                }
                                {
                                    textData?.product_data?.description && <div className="single-slide__single">
                                        <h6>Description:</h6>
                                        <p>{reactHtmlParser(ReactHtmlParser(textData?.product_data?.description))}</p>
                                    </div>
                                }

                                {
                                    textData?.product_data?.type && <div className="single-slide__single">
                                        <h6>Type</h6>
                                        <p>{reactHtmlParser(textData?.product_data?.type)}</p>
                                    </div>
                                }
                                {
                                    textData?.product_data?.address && <div className="single-slide__single">
                                        <h6>Address</h6>
                                        <p>{reactHtmlParser(textData?.product_data?.address)}</p>
                                    </div>
                                }

                                {
                                    textData?.product_data?.location && <div className="single-slide__single">
                                        <h6>General Location</h6>
                                        <p>{reactHtmlParser(textData?.product_data?.location)}</p>
                                    </div>
                                }

                                {
                                    textData?.product_data?.scale && <div className="single-slide__single">
                                        <h6>Scale</h6>
                                        <p>{reactHtmlParser(textData?.product_data?.scale)}</p>
                                    </div>
                                }

                                {
                                    textData?.product_data?.project_area && <div className="single-slide__single">
                                        <h6>Project Area</h6>
                                        <p>{ReactHtmlParser(textData?.product_data?.project_area)}</p>
                                    </div>
                                }

                                {
                                    textData?.product_data?.height && <div className="single-slide__single">
                                        <h6>Height</h6>
                                        <p>{textData?.product_data?.height}</p>
                                    </div>
                                }

                                {
                                    textData?.product_data?.owner && <div className="single-slide__single">
                                        <h6>Owner</h6>
                                        <p>{textData?.product_data?.owner}</p>
                                    </div>
                                }
                                {
                                    textData?.product_data?.owner_profession && <div className="single-slide__single">
                                        <h6>Owner Profession</h6>
                                        <p>{textData?.product_data?.owner_profession}</p>
                                    </div>
                                }

                                {
                                    textData?.product_data?.design_construction_period &&
                                    <div className="single-slide__single">
                                        <h6>Design & Construction Period</h6>
                                        <p>{textData?.product_data?.design_construction_period}</p>
                                    </div>
                                }

                                {
                                    textData?.product_data?.structural_engineer &&
                                    <div className="single-slide__single">
                                        <h6>Structural Engineer</h6>
                                        <p>{textData?.product_data?.structural_engineer}</p>
                                    </div>
                                }

                                {
                                    textData?.product_data?.if_any &&
                                    <div className="single-slide__single">
                                        <h6>Plumbing, Electrical Engineer ( if any )</h6>
                                        <p>{ReactHtmlParser(textData?.product_data?.if_any)}</p>
                                    </div>
                                }
                                {
                                    textData?.product_data?.project_cost &&
                                    <div className="single-slide__single">
                                        <h6>Project Cost:</h6>
                                        <p>{ReactHtmlParser(textData?.product_data?.project_cost)}</p>
                                    </div>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </LightgalleryProvider>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    .single-slide {
        overflow-y: scroll;
        height: 455px;

        /* For WebKit browsers */
        scrollbar-width: thin; /* Makes scrollbar thinner for Firefox */
        scrollbar-color: rgba(112, 112, 112, 0.5) transparent; /* Custom color for Firefox */
    }

    .single-slide::-webkit-scrollbar {
        width: 1px; /* Set the scrollbar width */
        background: transparent; /* Optional: Background of the scrollbar */
    }

    .single-slide::-webkit-scrollbar-thumb {
        background: rgba(112, 112, 112, 0.5); /* Color of the scrollbar thumb */
        border-radius: 5px; /* Rounded corners */
    }

    .single-slide::-webkit-scrollbar-thumb:hover {
        background: rgba(112, 112, 112, 0.5); /* Color when hovering over the scrollbar thumb */
    }

    .single-slide::-webkit-scrollbar-track {
        background: transparent; /* Optional: Track background color */
    }


    .single-slide__single {
        margin-bottom: 30px;
    }

    .right-button-prev {
        transform: rotate(180deg);
    }

    .right-button-next.dimmed,
    .right-button-prev.dimmed {
        opacity: 0.3;
        pointer-events: none;

    }

    .right-button-next, .right-button-prev {
        border: 1px solid rgb(112, 112, 112);
        height: 30px;
        width: 30px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .nav-menu {
        display: flex;
        justify-content: right;
        padding-top: 20px;
        gap: 10px;
    }

    .single-slide__single h5 {
        font-size: 18px;
        color: #000;
        font-weight: 400;
        line-height: 27px;
        margin-bottom: 30px;
    }

    .single-slide__single h6 {
        font-size: 14px;
        font-weight: bold;
        line-height: 21px;
        margin-bottom: 15px;
        color: #000;
    }

    .single-slide__single p {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        color: #000;
        padding-right: 30px;
        text-align: justify;
    }

    .img-item {
        position: relative;
        padding-top: calc(500 / 470 * 100%);
        cursor: pointer;
    }

    /* Tablet desktop :768px. */
    @media (min-width: 768px) and (max-width: 991px) {
        margin-left: 45px;
        .nav-menu {
            display: none;
        }

        .single-slide {
            margin-top: 30px;
        }
    }

    @media (max-width: 767px) {
        margin-left: unset;
        .nav-menu {
            display: none;
        }

        .single-slide {
            overflow-y: unset;
            height: unset;
        }

        .single-slide::-webkit-scrollbar {
            display: block;
        }

        .single-slide {
            margin-top: 30px;
        }
    }
`;

export default React.memo(DetailList);
